/**
 * Home Page Loader - WebGL Liquid Text Effect
 * Optimized version with responsive design, bubbles, force fields, and animated icons
 */

(function() {
  'use strict';

  // 只在主页执行
  if (window.location.pathname !== '/' && window.location.pathname !== '') {
    return;
  }

  // 等待 DOM 完全加载
  function initLoader() {
    const loaderContainer = document.getElementById('home-page-loader');
    const loadingScreen = document.getElementById('loading-screen');
    const mainContent = document.getElementById('main-content');
    
    if (!loaderContainer || !loadingScreen || !mainContent) {
      return;
    }

    // 读取移动端启用设置
    const enableMobile = loaderContainer.dataset.enableMobile === 'true';
    
    // 检测是否为移动设备
    const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
    
    // 如果是移动设备且未启用移动端 loader，直接跳过
    if (isMobileDevice && !enableMobile) {
      loaderContainer.classList.add('hidden');
      loaderContainer.classList.add('completely-hidden');
      document.body.style.overflow = '';
      document.body.style.height = 'auto';
      return;
    }

    // 检查是否已经在当前会话中显示过加载动画
    const hasSeenLoader = sessionStorage.getItem('homeLoaderShown');
    
    if (hasSeenLoader) {
      loaderContainer.classList.add('hidden');
      loaderContainer.classList.add('completely-hidden');
      document.body.style.overflow = '';
      return;
    }

    sessionStorage.setItem('homeLoaderShown', 'true');
    // 加载阶段锁定滚动
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100vh';

    let resourcesLoaded = false;
    let threeJSLoaded = false;
    let webGLFailed = false;
    let homePageResourcesReady = false;
    let hasEnteredHomePage = false; // 防止重复进入主页

    function checkResourcesLoaded() {
      // 只要基础资源加载完成，就显示波纹交互页面
      if (resourcesLoaded && threeJSLoaded) {
        showMainContent();
        // 在波纹页面显示后，开始预加载首页资源
        preloadHomePageResources();
      } else if (resourcesLoaded && webGLFailed) {
        // WebGL失败，直接进入首页
        enterHomePage();
      }
    }

    function preloadHomePageResources() {
    // 预加载关键图片
    const criticalImages = document.querySelectorAll('img[loading="eager"], img[fetchpriority="high"]');
    const imagePromises = Array.from(criticalImages).map(img => {
      return new Promise((resolve) => {
        if (img.complete) {
          resolve();
        } else {
          img.onload = resolve;
          img.onerror = resolve;
          if (!img.src && img.dataset.src) {
            img.src = img.dataset.src;
          }
        }
      });
    });
    
    Promise.all(imagePromises).then(() => {
      homePageResourcesReady = true;
      updateScrollHint();
    }).catch(() => {
      homePageResourcesReady = true;
      updateScrollHint();
    });
    
    // 设置超时保护：3秒后无论如何都标记为ready
    setTimeout(() => {
      if (!homePageResourcesReady) {
        homePageResourcesReady = true;
        updateScrollHint();
      }
    }, 3000);
  }

  function updateScrollHint() {
    const scrollHint = document.querySelector('.home-page-loader__scroll-hint');
    if (scrollHint && homePageResourcesReady) {
      // 资源加载完成，添加ready class用于视觉反馈（可选）
      scrollHint.classList.add('ready');
    }
  }

  function showMainContent() {
    setTimeout(() => {
      loadingScreen.classList.add('hidden');
      mainContent.classList.add('visible');
      
      // 启用滚动
      document.body.style.overflow = 'auto';
      document.body.style.height = 'auto';
      
      // 立即显示滚动提示
      setTimeout(() => {
        const scrollHint = document.querySelector('.home-page-loader__scroll-hint');
        if (scrollHint) {
          scrollHint.classList.add('visible');
        }
      }, 800);
      
      initScene();
      setupScrollDetection();
      
      // 如果启用了自动进入，启动计时器
      startAutoEnterTimer();
    }, 300);
  }

  function enterHomePage() {
    // 防止重复进入
    if (hasEnteredHomePage) return;
    hasEnteredHomePage = true;
    
    cancelAutoEnterTimer();
    
    // 重置滚动位置到顶部
    window.scrollTo(0, 0);
    
    loaderContainer.classList.add('hidden');
    document.body.style.overflow = '';
    
    // 释放资源
    if (window.loaderCleanup) {
      window.loaderCleanup();
    }
    
    setTimeout(() => {
      loaderContainer.classList.add('completely-hidden');
    }, 500);
  }

  let autoEnterTimer = null;
  let lastInteractionTime = Date.now();
  const INTERACTION_TIMEOUT = 3000; // 3秒无交互后重新启动计时器

  // 注意：以下自动进入功能已被滚动式交互替代，但保留代码以便将来通过设置重新启用
  // 当前默认使用滚动检测（setupScrollDetection），用户滚动到底部时自然进入主页
  
  function startAutoEnterTimer() {
    const autoEnterEnabled = loaderContainer.dataset.autoEnterEnabled === 'true';
    const autoEnterDelay = parseInt(loaderContainer.dataset.autoEnterDelay || '30', 10);
    
    if (!autoEnterEnabled) {
      return;
    }
    
    // 清除旧的计时器
    if (autoEnterTimer) {
      clearTimeout(autoEnterTimer);
    }
    
    autoEnterTimer = setTimeout(() => {
      // 检查最后交互时间
      const timeSinceLastInteraction = Date.now() - lastInteractionTime;
      
      if (timeSinceLastInteraction < INTERACTION_TIMEOUT) {
        // 用户最近有交互，延迟重试
        startAutoEnterTimer();
      } else {
        // 无交互，执行自动进入
        autoEnterHomePage();
      }
    }, autoEnterDelay * 1000);
  }

  function cancelAutoEnterTimer() {
    if (autoEnterTimer) {
      clearTimeout(autoEnterTimer);
      autoEnterTimer = null;
    }
  }
  
  function recordInteraction() {
    const now = Date.now();
    const timeSinceLastInteraction = now - lastInteractionTime;
    lastInteractionTime = now;
  }

  function autoEnterHomePage() {
    // 防止重复进入
    if (hasEnteredHomePage) return;
    hasEnteredHomePage = true;
    
    const scrollHint = document.querySelector('.home-page-loader__scroll-hint');
    if (scrollHint) scrollHint.classList.remove('visible');
    
    // 如果WebGL失败，直接进入
    if (webGLFailed) {
      enterHomePage();
      return;
    }
    
    mainContent.classList.add('slide-out');
    
    setTimeout(() => {
      loaderContainer.classList.add('hidden');
      document.body.style.overflow = '';
      
      // 释放资源：停止动画循环
      if (window.loaderCleanup) {
        window.loaderCleanup();
      }
      
      setTimeout(() => {
        loaderContainer.classList.add('completely-hidden');
      }, 500);
    }, 800);
  }

  // 全局错误处理
  let errorCount = 0;
  const MAX_ERRORS = 3;
  
  function handleLoaderError(error, source) {
    errorCount++;
    
    if (errorCount >= MAX_ERRORS) {
      webGLFailed = true;
      resourcesLoaded = true;
      checkResourcesLoaded();
    }
  }
  
  window.addEventListener('error', (event) => {
    if (loaderContainer && !loaderContainer.classList.contains('hidden')) {
      handleLoaderError(event.error, 'window.error');
    }
  });
  
  window.addEventListener('unhandledrejection', (event) => {
    if (loaderContainer && !loaderContainer.classList.contains('hidden')) {
      handleLoaderError(event.reason, 'unhandledrejection');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      resourcesLoaded = true;
      checkResourcesLoaded();
    });
  } else {
    resourcesLoaded = true;
    checkResourcesLoaded();
  }

  function checkThreeJS() {
    if (typeof THREE !== 'undefined') {
      threeJSLoaded = true;
      checkResourcesLoaded();
    } else {
      setTimeout(checkThreeJS, 50);
    }
  }
  
  // 添加 Three.js 加载超时检测
  let threeJSCheckCount = 0;
  const originalCheckThreeJS = checkThreeJS;
  checkThreeJS = function() {
    threeJSCheckCount++;
    if (threeJSCheckCount > 80) { // 80 * 50ms = 4秒
      webGLFailed = true;
      threeJSLoaded = true;
      checkResourcesLoaded();
      return;
    }
    originalCheckThreeJS();
  };
  
  checkThreeJS();

  // 超时保护：4秒后如果还没显示内容，强制显示波纹页面或进入首页
  setTimeout(() => {
    if (!mainContent.classList.contains('visible') && !loaderContainer.classList.contains('hidden')) {
      threeJSLoaded = true;
      resourcesLoaded = true;
      webGLFailed = true;
      checkResourcesLoaded();
    }
  }, 4000);
  
  // 额外的紧急超时：60秒后如果真的卡在加载屏幕（主内容没显示），强制进入首页
  // 这只在真正卡住时触发，不会影响正常交互
  setTimeout(() => {
    // 检查是否真的卡住了：主内容没显示 且 loader 还在显示
    const mainContentVisible = mainContent.classList.contains('visible');
    const loaderHidden = loaderContainer.classList.contains('hidden');
    
    if (!mainContentVisible && !loaderHidden) {
      enterHomePage();
    }
  }, 60000);

  function setupScrollDetection() {
    let isNavigating = false;
    const triggerDistance = window.innerHeight / 3; // 屏幕高度的 1/3
    
    // 监听滚动事件
    window.addEventListener('scroll', () => {
      if (isNavigating || hasEnteredHomePage) return; // 检查是否已进入
      
      // 获取滚动位置
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // 当滚动距离达到屏幕高度的 1/3 时进入主页
      if (scrollTop >= triggerDistance) {
        isNavigating = true;
        
        // 取消自动进入计时器（如果有）
        cancelAutoEnterTimer();
        
        const scrollHint = document.querySelector('.home-page-loader__scroll-hint');
        if (scrollHint) scrollHint.classList.remove('visible');
        
        // 平滑过渡到主页
        loaderContainer.style.transition = 'opacity 0.8s ease-out';
        loaderContainer.classList.add('hidden');
        
        setTimeout(() => {
          enterHomePage();
        }, 800);
      }
    }, { passive: true });
  }

  // 响应式配置
  const getResponsiveConfig = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const isLandscape = width > height;
    
    const breakpoints = { mobile: 480, tablet: 768, desktop: 1920 };
    const deviceType = width <= breakpoints.mobile ? 'mobile' :
                      width <= breakpoints.tablet ? 'tablet' :
                      width >= breakpoints.desktop ? 'large-desktop' : 'desktop';
    
    const navHeight = isLandscape && height <= 500 ? 45 :
                     deviceType === 'mobile' ? 50 :
                     deviceType === 'tablet' ? 60 : 86;
    
    const fontSize = deviceType === 'mobile' ? 180 :
                    deviceType === 'tablet' ? 280 : 480;
    
    const lineGap = deviceType === 'mobile' || deviceType === 'tablet' ? 3 : 0;
    const bubbleCount = deviceType === 'mobile' ? 30 :
                       deviceType === 'tablet' ? 45 : 60;
    
    return {
      width, height, deviceType, isLandscape,
      isMobile: deviceType === 'mobile',
      isTablet: deviceType === 'tablet',
      navHeight, fontSize, lineGap, bubbleCount
    };
  };

  function initScene() {
    if (typeof THREE === 'undefined') return;

    const container = document.getElementById('canvas-container');
    if (!container) return;

    // 读取变形强度设置
    const deformStrength = loaderContainer.dataset.deformStrength || 'medium';
    const mouseTransparent = loaderContainer.dataset.mouseTransparent === 'true';
    
    // 根据设置定义变形参数
    const deformConfig = {
      small: {
        mainFlowMultiplier: 0.03,
        redFlowMultiplier: 0.02,
        deformStrength: 0.02
      },
      medium: {
        mainFlowMultiplier: 0.07,
        redFlowMultiplier: 0.05,
        deformStrength: 0.03
      },
      large: {
        mainFlowMultiplier: 0.12,
        redFlowMultiplier: 0.08,
        deformStrength: 0.05
      }
    };
    
    const currentDeform = deformConfig[deformStrength] || deformConfig.medium;

    const scene = new THREE.Scene();
    const camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
    
    let renderer;
    try {
      renderer = new THREE.WebGLRenderer({ 
        alpha: true, 
        premultipliedAlpha: false, 
        antialias: true,
        powerPreference: 'high-performance',
        failIfMajorPerformanceCaveat: false
      });
      renderer.setClearColor(0x000000, 0);
    } catch (error) {
      handleLoaderError(error, 'WebGL init');
      webGLFailed = true;
      
      // 直接进入首页
      setTimeout(() => {
        enterHomePage();
      }, 500);
      return;
    }
    
    const canvas = renderer.domElement;
    canvas.addEventListener('webglcontextlost', (event) => {
      event.preventDefault();
      handleLoaderError(new Error('WebGL context lost'), 'contextlost');
      cancelAnimationFrame(animationId);
      
      setTimeout(() => {
        webGLFailed = true;
        enterHomePage();
      }, 1000);
    }, false);
    
    canvas.addEventListener('webglcontextrestored', () => {
      try {
        const newTexture = createTextTexture();
        if (displayMaterial) {
          displayMaterial.uniforms.uTexture.value = newTexture;
          displayMaterial.uniforms.uTexture.value.needsUpdate = true;
        }
        animate();
      } catch (error) {
        handleLoaderError(error, 'contextrestored');
        webGLFailed = true;
        enterHomePage();
      }
    }, false);
    
    let config = getResponsiveConfig();
    const maxPixelRatio = config.isMobile ? 2 : (config.isTablet ? 2 : 3);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, maxPixelRatio));
    renderer.setSize(window.innerWidth, window.innerHeight);
    container.appendChild(canvas);

    // 流体物理模拟系统
    const RESOLUTION = 128;
    
    function createFBO() {
      return new THREE.WebGLRenderTarget(RESOLUTION, RESOLUTION, {
        type: THREE.HalfFloatType,
        format: THREE.RGBAFormat,
        magFilter: THREE.LinearFilter,
        minFilter: THREE.LinearFilter
      });
    }
    
    let velocityFBO_A = createFBO();
    let velocityFBO_B = createFBO();
    
    // 物理模拟Shader
    const simulationMaterial = new THREE.ShaderMaterial({
      uniforms: {
        uVelocity: { value: null },
        uMouse: { value: new THREE.Vector2(0.5, 0.5) },
        uDir: { value: new THREE.Vector2(0, 0) },
        uStrength: { value: 0 },
        uAspect: { value: window.innerWidth / window.innerHeight }
      },
      vertexShader: `
        varying vec2 vUv;
        void main() {
          vUv = uv;
          gl_Position = vec4(position, 1.0);
        }
      `,
      fragmentShader: `
        uniform sampler2D uVelocity;
        uniform vec2 uMouse;
        uniform vec2 uDir;
        uniform float uStrength;
        uniform float uAspect;
        varying vec2 vUv;
        
        void main() {
          vec2 vel = texture2D(uVelocity, vUv).rg;
          vec2 prevUv = vUv - vel * 0.01;
          vec2 newVel = texture2D(uVelocity, prevUv).rg * 0.98;
          
          vec2 aspectUv = vec2(vUv.x * uAspect, vUv.y);
          vec2 aspectMouse = vec2(uMouse.x * uAspect, uMouse.y);
          float d = distance(aspectUv, aspectMouse);
          
          float force = exp(-d * d / 0.0025) * uStrength;
          newVel += uDir * force * 0.5;
          
          gl_FragColor = vec4(newVel, 0.0, 1.0);
        }
      `
    });

    // Icon scheduling system
    const iconSchedule = [];
    let lastIcon = null;
    
    function generateIconSchedule(startTime, duration = 60) {
      const schedule = [];
      let currentTime = startTime;
      
      while (currentTime < startTime + duration) {
        const options = [0, 0, 'sup', 'splash', 'drink'];
        const availableOptions = options.filter(opt => opt === 0 || opt !== lastIcon);
        const firstSelected = availableOptions[Math.floor(Math.random() * availableOptions.length)];
        
        let firstDuration = 0;
        
        if (firstSelected === 0) {
          firstDuration = 1.5 + Math.random() * 1.5;
          schedule.push({ time: currentTime, icon: null, duration: firstDuration });
          currentTime += firstDuration;
        } else {
          lastIcon = firstSelected;
          firstDuration = firstSelected === 'sup' ? 4.5 : (firstSelected === 'splash' ? 4.0 : 5.0);
          schedule.push({ time: currentTime, icon: firstSelected, duration: firstDuration });
          
          const secondOptions = [0, 0, 'sup', 'splash', 'drink'];
          const secondAvailable = secondOptions.filter(opt => opt === 0 || opt !== firstSelected);
          const secondSelected = secondAvailable[Math.floor(Math.random() * secondAvailable.length)];
          const secondStartTime = currentTime + firstDuration;
          
          if (secondSelected === 0) {
            const secondDuration = 1.5 + Math.random() * 1.5;
            schedule.push({ time: secondStartTime, icon: null, duration: secondDuration });
            currentTime = secondStartTime + secondDuration;
          } else {
            lastIcon = secondSelected;
            const secondDuration = secondSelected === 'sup' ? 4.5 : (secondSelected === 'splash' ? 4.0 : 5.0);
            schedule.push({ time: secondStartTime, icon: secondSelected, duration: secondDuration });
            currentTime = secondStartTime + secondDuration;
          }
        }
      }
      return schedule;
    }
    
    iconSchedule.push(...generateIconSchedule(0, 120));
    
    function getActiveIcons(time) {
      const active = [];
      for (let i = 0; i < iconSchedule.length; i++) {
        const event = iconSchedule[i];
        if (event.time > time) break;
        if (event.icon === null) continue;
        
        const elapsed = time - event.time;
        if (elapsed < event.duration) {
          active.push({
            icon: event.icon,
            startTime: event.time,
            duration: event.duration,
            progress: elapsed / event.duration
          });
        }
      }
      
      if (iconSchedule.length > 0) {
        const lastTime = iconSchedule[iconSchedule.length - 1].time;
        if (time > lastTime - 30) {
          iconSchedule.push(...generateIconSchedule(lastTime, 60));
        }
      }
      return active;
    }

    function createTextTexture(time = 0) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d', { alpha: true, willReadFrequently: false });
      
      const config = getResponsiveConfig();
      const baseSizes = {
        'mobile': { width: 1440, height: 1024 },
        'tablet': { width: 1920, height: 1366 },
        'desktop': { width: 2880, height: 2048 },
        'large-desktop': { width: 2880, height: 2048 }
      };
      
      const baseSize = baseSizes[config.deviceType] || baseSizes.desktop;
      const baseWidth = baseSize.width;
      const baseHeight = baseSize.height;
      const maxDPR = config.isMobile ? 2 : (config.isTablet ? 2 : 3);
      const dpr = Math.min(window.devicePixelRatio || 1, maxDPR);
      
      canvas.width = baseWidth * dpr;
      canvas.height = baseHeight * dpr;
      ctx.scale(dpr, dpr);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      
      ctx.fillStyle = '#fffee1';
      ctx.fillRect(0, 0, baseWidth, baseHeight);

      const navHeight = (config.navHeight / 1024) * baseHeight;
      const contentTop = navHeight;
      const contentHeight = baseHeight - navHeight;
      const textAreaTop = contentTop + contentHeight * 0.20;
      const textAreaHeight = contentHeight * 0.60;
      
      ctx.textAlign = 'center';
      ctx.fillStyle = '#42ceff';
      const centerY = textAreaTop + textAreaHeight / 2;
      
      // 从 data 属性读取文字内容
      const textLine1 = loaderContainer.dataset.textLine1 || 'Make a';
      const textLine2 = loaderContainer.dataset.textLine2 || 'Splash!';
      
      ctx.save();
      ctx.font = `700 ${config.fontSize}px "Syne", "Arial", sans-serif`;
      ctx.textBaseline = 'bottom';
      ctx.translate(baseWidth / 2, centerY - config.lineGap / 2);
      ctx.scale(1, 1.9);
      ctx.fillText(textLine1, 0, 0);
      ctx.restore();

      ctx.save();
      ctx.font = `700 ${config.fontSize}px "Syne", "Arial", sans-serif`;
      ctx.textBaseline = 'top';
      ctx.translate(baseWidth / 2, centerY + config.lineGap / 2);
      ctx.scale(1, 1.9);
      ctx.fillText(textLine2, 0, 0);
      ctx.restore();
      
      const activeIcons = getActiveIcons(time);
      
      activeIcons.forEach(iconData => {
        const { icon, progress } = iconData;
        let opacity = 1.0;
        if (progress < 0.1) opacity = progress / 0.1;
        else if (progress > 0.9) opacity = (1.0 - progress) / 0.1;
        if (opacity < 0.01) return;
        
        const flowPhase = Math.sin(time * 0.8);
        const rotationAngle = flowPhase * 0.3;
        
        if (icon === 'sup') {
          const baseScale = config.isMobile ? 0.7 : (config.isTablet ? 0.9 : 1.2);
          const supScale = baseScale * dpr;
          const supX = baseWidth / 2;
          const supStartY = baseHeight + 150;
          const supEndY = -150;
          const supY = supStartY + (supEndY - supStartY) * progress;
          
          ctx.save();
          ctx.globalAlpha = opacity;
          ctx.translate(supX, supY);
          ctx.rotate(rotationAngle);
          ctx.scale(supScale, supScale);
          ctx.translate(-123.15/2, -101.09/2);
          ctx.fillStyle = '#42ceff';
          ctx.strokeStyle = '#42ceff';
          ctx.lineWidth = 6;
          ctx.lineCap = 'round';
          ctx.lineJoin = 'round';
          
          const slooshPath = new Path2D("M30.01,38.8c.4.96.32,1.76-.03,2.46-.4.79-.99,1.31-1.89,1.69-1.2.5-2.42.49-3.28.15-.08-.03-.12-.12-.09-.2l.52-1.73c.02-.08.11-.12.19-.1.75.23,1.36.16,1.93-.07.66-.27.93-.78.74-1.22-.2-.48-.7-.62-1.5-.47-.59.12-1.33.16-2.15-.04-.72-.18-1.33-.69-1.62-1.39-.42-1-.26-1.87.08-2.51.31-.59.92-1.23,1.91-1.64.79-.33,1.66-.38,2.54-.19.09.02.15.12.12.21l-.51,1.71c-.02.08-.1.12-.18.1-.41-.1-.82-.06-1.24.12-.66.27-.99.76-.79,1.25.3.72,1.24.45,2,.34.72-.11,1.34-.1,1.91.16.5.23,1.03.64,1.34,1.39h0ZM57.65,27.34c.4.96.32,1.76-.03,2.46-.4.79-.99,1.31-1.89,1.69-1.2.5-2.42.49-3.28.15-.08-.03-.12-.12-.09-.2l.53-1.73c.02-.08.11-.12.19-.1.75.23,1.36.16,1.93-.07.66-.27.93-.78.74-1.22-.2-.48-.7-.62-1.5-.47-.59.12-1.33.16-2.15-.04-.72-.18-1.33-.69-1.62-1.39-.41-.99-.25-1.87.08-2.51.31-.59.92-1.23,1.91-1.64.79-.33,1.66-.38,2.54-.19.09.02.15.12.12.21l-.51,1.71c-.02.08-.1.12-.18.1-.41-.1-.82-.06-1.24.12-.66.27-.99.76-.79,1.25.3.72,1.24.45,2,.34.72-.11,1.34-.1,1.91.16.5.23,1.03.64,1.34,1.39h0ZM63.15,17.91l-1.66.69c-.08.03-.11.12-.08.21l1.31,3.15-3.23,1.34-1.31-3.15c-.03-.08-.12-.12-.2-.09l-1.66.69c-.08.03-.11.12-.08.21l3.56,8.59c.03.08.12.12.2.09l1.66-.69c.08-.03.11-.12.08-.21l-1.47-3.55,3.23-1.34,1.47,3.55c.03.08.12.12.2.09l1.66-.69c.08-.03.11-.12.08-.21l-3.56-8.59c-.03-.08-.13-.12-.2-.09ZM33.39,38.45l-2.84-6.85c-.03-.08-.12-.12-.2-.09l-1.66.69c-.08.03-.11.12-.08.21l3.56,8.59c.03.08.12.12.2.09l4.91-2.04c.08-.03.11-.12.08-.21l-.66-1.59c-.03-.08-.12-.12-.2-.09l-3.11,1.29ZM48.12,25.69c-1.1-.56-2.29-.68-3.45-.2-.79.33-1.31.9-1.65,1.56-.35.67-.46,1.34-.58,3.02-.11,1.68-.09,2.48-.41,3.74-.24.94-.7,1.48-1.5,1.81-.57.24-1.13.17-1.65-.12-.55-.31-1.03-.89-1.39-1.76s-.41-1.58-.26-2.22c.12-.52.49-1.01,1.08-1.25.78-.33,1.41-.06,2.01.36.52.36.98.9,1.31,1.38.04.06.13.04.14-.03.09-.74.14-1.48.17-2.22,0-.07-.02-.13-.07-.18-.63-.67-1.18-1.04-1.89-1.27-.75-.25-1.57-.24-2.36.08-1.07.44-1.92,1.36-2.29,2.58-.34,1.13-.26,2.32.25,3.56s1.36,2.2,2.34,2.69c1.1.56,2.29.68,3.45.2.79-.33,1.31-.9,1.65-1.56.35-.67.46-1.34.58-3.02.11-1.68.09-2.48.41-3.74.24-.94.7-1.48,1.5-1.81.57-.24,1.14-.17,1.65.12.55.31,1.03.89,1.38,1.76.36.87.41,1.58.26,2.22-.12.52-.49,1.01-1.08,1.25-.78.33-1.41.06-2.01-.36-.52-.36-.98-.9-1.31-1.38-.04-.06-.13-.04-.14.03-.09.74-.14,1.48-.16,2.22,0,.07.02.13.07.18.63.67,1.18,1.04,1.89,1.27.76.25,1.58.24,2.36-.08,1.07-.44,1.92-1.36,2.29-2.58.34-1.13.26-2.32-.25-3.56-.51-1.23-1.36-2.2-2.34-2.69h0Z");
          ctx.fill(slooshPath);
          
          ctx.beginPath();
          ctx.moveTo(102.46,7.14);
          ctx.bezierCurveTo(102.56,7.39,102.67,7.95,102.43,8.98);
          ctx.bezierCurveTo(102.2,10,101.68,11.29,100.79,12.84);
          ctx.bezierCurveTo(99.01,15.92,95.98,19.65,91.79,23.64);
          ctx.bezierCurveTo(83.43,31.59,70.79,40.26,55.44,46.62);
          ctx.bezierCurveTo(39.85,53.08,27.99,56.37,19.46,56.45);
          ctx.bezierCurveTo(15.24,56.49,12.02,55.74,9.59,54.35);
          ctx.bezierCurveTo(7.21,52.99,5.39,50.91,4.14,47.89);
          ctx.bezierCurveTo(2.89,44.87,2.7,42.11,3.42,39.46);
          ctx.bezierCurveTo(4.16,36.77,5.9,33.96,8.91,31);
          ctx.bezierCurveTo(14.99,25.02,25.7,18.96,41.3,12.49);
          ctx.bezierCurveTo(56.65,6.13,71.71,3.31,83.25,3.02);
          ctx.bezierCurveTo(89.03,2.87,93.81,3.36,97.25,4.29);
          ctx.bezierCurveTo(98.97,4.75,100.25,5.3,101.14,5.86);
          ctx.bezierCurveTo(102.04,6.42,102.36,6.89,102.46,7.14);
          ctx.stroke();
          
          ctx.beginPath();
          ctx.moveTo(48.6,77.72);
          ctx.bezierCurveTo(49.35,79.54,49.04,81.52,47.52,82.81);
          ctx.lineTo(30.54,97.21);
          ctx.bezierCurveTo(28.6,98.86,25.27,98.21,24.05,95.26);
          ctx.lineTo(18.84,82.69);
          ctx.bezierCurveTo(17.62,79.74,19.51,76.93,22.05,76.72);
          ctx.lineTo(44.23,74.89);
          ctx.bezierCurveTo(46.21,74.73,47.84,75.91,48.6,77.72);
          ctx.closePath();
          ctx.stroke();
          
          ctx.beginPath();
          ctx.moveTo(119.72,48.49);
          ctx.lineTo(49.55,77.57);
          ctx.stroke();
          
          ctx.beginPath();
          ctx.moveTo(102.07,7.3);
          ctx.bezierCurveTo(101.1,4.96,72.67,3.92,65.65,5.27);
          ctx.bezierCurveTo(65.65,5.27,77.92,6.72,81.66,15.76);
          ctx.bezierCurveTo(85.4,24.79,77.76,34.5,77.76,34.5);
          ctx.bezierCurveTo(83.65,31.12,103.03,9.64,102.07,7.3);
          ctx.closePath();
          ctx.fill();
          ctx.stroke();
          
          ctx.beginPath();
          ctx.moveTo(120.15,55.85);
          ctx.lineTo(114.86,43.1);
          ctx.stroke();
          ctx.restore();
        
        } else if (icon === 'splash') {
          const baseScale = config.isMobile ? 0.55 : (config.isTablet ? 0.7 : 0.88);
          const splashScale = baseScale * dpr;
          const splashX = baseWidth * 0.97 - (140.66 * baseScale) / 2;
          const splashStartY = baseHeight + 200;
          const splashEndY = -200;
          const splashY = splashStartY + (splashEndY - splashStartY) * progress;
        
          ctx.save();
          ctx.globalAlpha = opacity;
          ctx.translate(splashX, splashY);
          ctx.rotate(rotationAngle);
          ctx.scale(splashScale, splashScale);
          ctx.translate(-140.66/2, -129.51/2);
          ctx.strokeStyle = '#42ceff';
          ctx.fillStyle = '#42ceff';
          ctx.lineWidth = 10;
          ctx.lineCap = 'round';
          
          ctx.beginPath();
          ctx.arc(71.28, 62.53, 38.43, 0, Math.PI * 2);
          ctx.stroke();
          
          ctx.beginPath();
          ctx.moveTo(94.67, 5); ctx.lineTo(93.52, 9.13);
          ctx.moveTo(131.76, 36.44); ctx.lineTo(128.03, 38.55);
          ctx.moveTo(108.02, 56.89); ctx.lineTo(51.68, 64.4);
          ctx.moveTo(47.86, 5); ctx.lineTo(49.58, 8.94);
          ctx.moveTo(111.71, 109.44); ctx.lineTo(114.21, 112.93);
          ctx.moveTo(11.33, 34.31); ctx.lineTo(15.46, 35.71);
          ctx.moveTo(131.53, 79.62); ctx.lineTo(135.66, 81.02);
          ctx.moveTo(5, 76.48); ctx.lineTo(9.26, 75.61);
          ctx.moveTo(28.29, 113.97); ctx.lineTo(31.05, 110.65);
          ctx.moveTo(71.59, 124.51); ctx.lineTo(71.38, 120.23);
          ctx.stroke();
          
          const splash1 = new Path2D("M61.02,68.24c1.5,11.75-6.69,13.28-17.38,14.99-10.69,1.71-17.84,1.75-21.32-8.79-4.36-13.2,6.84-12.4,17.53-14.11,21.17-3.39,19.12-1.88,21.17,7.91Z");
          const splash2 = new Path2D("M104.59,61.98c1.5,11.75-6.69,13.28-17.38,14.99-10.69,1.71-17.84,1.75-21.32-8.79-4.36-13.2,6.84-12.4,17.53-14.11,21.17-3.39,19.12-1.88,21.17,7.91Z");
          ctx.fill(splash1);
          ctx.fill(splash2);
          ctx.restore();
        
        } else if (icon === 'drink') {
          const baseScale = config.isMobile ? 0.7 : (config.isTablet ? 0.9 : 1.19);
          const drinkScale = baseScale * dpr;
          const drinkX = baseWidth * 0.03 + (83.91 * baseScale) / 2;
          const drinkStartY = baseHeight + 150;
          const drinkEndY = -150;
          const drinkY = drinkStartY + (drinkEndY - drinkStartY) * progress;
          
          ctx.save();
          ctx.globalAlpha = opacity;
          ctx.translate(drinkX, drinkY);
          ctx.rotate(rotationAngle);
          ctx.scale(drinkScale, drinkScale);
          ctx.translate(-83.91/2, -101.63/2);
          ctx.strokeStyle = '#42ceff';
          ctx.fillStyle = '#42ceff';
          ctx.lineWidth = 7;
          ctx.lineCap = 'round';
          ctx.lineJoin = 'miter';
          
          const drinkBody = new Path2D("M31.8,59.51c-2.19-5.04.3-10.93,5.33-12.67l24.07-8.3c5.04-1.74,10.41,1.45,11.54,6.85l7.45,35.53c.98,4.65-1.58,9.33-5.92,10.82l-17.14,5.91c-4.34,1.5-9.07-.66-10.96-5l-14.39-33.14Z");
          ctx.stroke(drinkBody);
          
          const drinkStraw = new Path2D("M59.28,75.93l-13.28-49.13c-.99-3.67.41-7.6,3.47-9.69l9.23-6.33");
          ctx.stroke(drinkStraw);
          
          ctx.beginPath();
          ctx.arc(14.38, 45.91, 3.5, 0, Math.PI * 2);
          ctx.fill();
          ctx.beginPath();
          ctx.arc(75.37, 24.23, 3.1, 0, Math.PI * 2);
          ctx.fill();
          ctx.beginPath();
          ctx.arc(76.66, 2.95, 3.5, 0, Math.PI * 2);
          ctx.fill();
          ctx.beginPath();
          ctx.arc(28.85, 24.03, 3.3, 0, Math.PI * 2);
          ctx.fill();
          ctx.beginPath();
          ctx.arc(2.98, 28.34, 3.7, 0, Math.PI * 2);
          ctx.fill();
          
          ctx.beginPath();
          ctx.moveTo(36.35, 69.98);
          ctx.lineTo(74.84, 57.07);
          ctx.stroke();
          ctx.restore();
        }
      });

      const texture = new THREE.CanvasTexture(canvas);
      texture.needsUpdate = true;
      texture.minFilter = THREE.LinearFilter;
      texture.magFilter = THREE.LinearFilter;
      texture.anisotropy = renderer.capabilities.getMaxAnisotropy();
      return texture;
    }

    async function initTextTexture() {
      await document.fonts.load('700 480px "Syne"');
      return createTextTexture();
    }

    let textTexture;
    initTextTexture().then(texture => {
      textTexture = texture;
      if (displayMaterial) {
        displayMaterial.uniforms.uTexture.value = textTexture;
        displayMaterial.uniforms.uTexture.value.needsUpdate = true;
      }
    });
    
    textTexture = createTextTexture();
    
    const vertexShader = `
      varying vec2 vUv;
      void main() {
        vUv = uv;
        gl_Position = vec4(position, 1.0);
      }
    `;

    const fragmentShader = `
      uniform float uTime;
      uniform vec2 uResolution;
      uniform sampler2D uTexture;
      uniform float uBubbleCount;
      uniform float uMainFlowMultiplier;
      uniform float uRedFlowMultiplier;
      uniform float uDeformStrength;
      uniform sampler2D uVelocity;
      uniform float uMouseTransparent;
      varying vec2 vUv;

      vec3 mod289(vec3 x) { return x - floor(x * (1.0 / 289.0)) * 289.0; }
      vec2 mod289(vec2 x) { return x - floor(x * (1.0 / 289.0)) * 289.0; }
      vec3 permute(vec3 x) { return mod289(((x*34.0)+1.0)*x); }

      float snoise(vec2 v) {
        const vec4 C = vec4(0.211324865405187, 0.366025403784439, -0.577350269189626, 0.024390243902439);
        vec2 i  = floor(v + dot(v, C.yy));
        vec2 x0 = v - i + dot(i, C.xx);
        vec2 i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
        vec4 x12 = x0.xyxy + C.xxzz;
        x12.xy -= i1;
        i = mod289(i);
        vec3 p = permute(permute(i.y + vec3(0.0, i1.y, 1.0)) + i.x + vec3(0.0, i1.x, 1.0));
        vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0);
        m = m*m; m = m*m;
        vec3 x = 2.0 * fract(p * C.www) - 1.0;
        vec3 h = abs(x) - 0.5;
        vec3 ox = floor(x + 0.5);
        vec3 a0 = x - ox;
        m *= 1.79284291400159 - 0.85373472095314 * (a0*a0 + h*h);
        vec3 g;
        g.x  = a0.x  * x0.x  + h.x  * x0.y;
        g.yz = a0.yz * x12.xz + h.yz * x12.yw;
        return 130.0 * dot(m, g);
      }

      void main() {
        vec2 uv = vUv;
        
        // 从速度场采样（鼠标交互）
        vec2 velocity = texture2D(uVelocity, uv).rg;
        
        float horizontalWave = sin(uTime * 0.8) * 0.5;
        vec2 mainFlowOffset = vec2(horizontalWave, uTime * 0.45);
        float verticalPosition = abs(uv.y - 0.5) * 2.0;
        float flowStrength = 1.0 - verticalPosition;
        flowStrength = flowStrength * flowStrength;
        vec2 mainFlowField = vec2(sin(uTime * 0.8) * flowStrength * 1.2, 0.1);
        
        const int octaves = 3;
        float lacunarity = 2.0;
        float gain = 0.5;
        vec2 flowField = vec2(0.0);
        float amplitude = 1.0;
        float frequency = 1.0;
        
        for(int i = 0; i < octaves; i++) {
          float noiseX = snoise((uv + vec2(0.0, 0.0)) * frequency + uTime * 0.3);
          float noiseY = snoise((uv + vec2(5.2, 1.3)) * frequency + uTime * 0.3);
          flowField += vec2(noiseX, noiseY) * amplitude;
          frequency *= lacunarity;
          amplitude *= gain;
        }
        
        flowField.y += sin(uv.x * 3.14159 * 2.0 + uTime * 0.5) * 0.3;
        vec2 toCenter = uv - vec2(0.5, 0.5);
        float dist = length(toCenter);
        float vortex = sin(dist * 10.0 - uTime * 2.0) * 0.1;
        flowField += vec2(-toCenter.y, toCenter.x) * vortex;
        float directionChange = sin(uTime * 0.3) * 0.5 + 0.5;
        vec2 flowFieldVaried = mix(flowField, -flowField, directionChange * 0.3);
        
        float mediumFlow = snoise(uv * 3.5 + flowFieldVaried * 0.8 + uTime * 1.2);
        float smallFlow = snoise(uv * 6.0 + flowFieldVaried * 0.5 + uTime * 1.6);
        float microFlow = snoise(uv * 10.0 + flowFieldVaried * 0.3 + uTime * 2.1);
        vec2 redFieldFlow = vec2(mediumFlow * 0.25 + smallFlow * 0.1 + microFlow * 0.05, mediumFlow * 0.2 + smallFlow * 0.1);
        
        float slowWave = sin(uTime * 0.25) * 0.5 + 0.5;
        float fastWave = sin(uTime * 0.35 + uv.x * 3.0) * 0.5 + 0.5;
        float deformStrength = (slowWave * 0.5 + fastWave * 0.5) * uDeformStrength;
        
        // 结合背景流场和鼠标速度场
        // velocity 产生鼠标交互的形变效果
        vec2 textUV = uv + mainFlowField * uMainFlowMultiplier + redFieldFlow * deformStrength - velocity * 0.1;
        textUV = clamp(textUV, 0.0, 1.0);
        vec4 texColor = texture2D(uTexture, textUV);
        vec3 baseColor = texColor.rgb;
        vec3 backgroundColor = vec3(1.0, 0.996, 0.882);
        float colorDiff = length(baseColor - backgroundColor);
        float isText = step(0.15, colorDiff);
        float mainFlow = snoise(uv * 1.2 + mainFlowOffset);
        
        if (isText > 0.5) {
          vec3 textColor = vec3(0.0, 0.0, 0.0);
          float textAlpha = 0.15;
          float organicShape = mainFlow * 0.5 + mediumFlow * 0.25 + smallFlow * 0.1 + microFlow * 0.05;
          float cutoutMask = step(-0.2, organicShape);
          vec3 fieldColor = vec3(0.259, 0.808, 1.0);
          vec3 mixedColor = mix(textColor, fieldColor, cutoutMask);
          baseColor = mix(backgroundColor, mixedColor, mix(textAlpha, 1.0, cutoutMask));
        }
        
        // 鼠标交互效果
        float velocityStrength = length(velocity);
        float trailMask = smoothstep(0.02, 0.15, velocityStrength);
        
        if (uMouseTransparent < 0.5) {
          // 白色高亮模式：水流般的高亮效果
          vec3 highlightColor = vec3(1.0, 1.0, 1.0); // 纯白色高亮
          float highlightStrength = trailMask * 0.35;
          baseColor = mix(baseColor, highlightColor, highlightStrength);
        }
        // 透明模式：不添加任何颜色效果，只保留形变
        
        vec3 bubbleLayer = vec3(0.0);
        float aspect = uResolution.x / uResolution.y;
        vec2 correctedUV = vec2(uv.x * aspect, uv.y);
        
        for(int i = 0; i < 127; i++) {
          if(float(i) >= uBubbleCount) break;
          float fi = float(i);
          float bubbleX = fract(sin(fi * 12.9898) * 43758.5453);
          float sizeRandom = fract(sin(fi * 45.123) * 43758.5453);
          float bubbleSize = 0.002 + (sizeRandom * sizeRandom) * 0.005;
          float bubbleSpeed = 0.1 + ((bubbleSize - 0.002) / 0.005) * 0.4;
          float bubbleY = mod(uTime * bubbleSpeed + fi * 0.1, 1.3) - 0.15;
          if(bubbleY < -0.2 || bubbleY > 1.2) continue;
          float drift = sin(uTime * 0.5 + fi * 2.0) * 0.05;
          bubbleX += drift;
          vec2 bubblePos = vec2(bubbleX, bubbleY);
          vec2 correctedBubblePos = vec2(bubblePos.x * aspect, bubblePos.y);
          float quickDist = distance(correctedUV, correctedBubblePos);
          if(quickDist > bubbleSize * 2.5) continue;
          vec2 offset = correctedUV - correctedBubblePos;
          float verticalStretch = 1.1;
          float yNorm = offset.y / bubbleSize;
          float horizontalScale = 1.0 + yNorm * (yNorm > 0.0 ? 0.15 : 0.05);
          float dx = offset.x / (bubbleSize * horizontalScale);
          float dy = offset.y / (bubbleSize * verticalStretch);
          float d = sqrt(dx * dx + dy * dy);
          float bubbleCore = 1.0 - smoothstep(0.6, 1.2, d);
          if(bubbleCore < 0.01) continue;
          float radialGradient = 1.0 - smoothstep(0.0, 1.0, d);
          vec2 highlightPos = correctedBubblePos + vec2(-bubbleSize * 0.3, bubbleSize * 0.35);
          float highlightDist = distance(correctedUV, highlightPos);
          float highlight = 1.0 - smoothstep(0.0, bubbleSize * 0.35, highlightDist);
          highlight = highlight * highlight * highlight;
          vec2 shadowPos = correctedBubblePos + vec2(bubbleSize * 0.2, -bubbleSize * 0.25);
          float shadowDist = distance(correctedUV, shadowPos);
          float innerShadow = 1.0 - smoothstep(0.0, bubbleSize * 0.5, shadowDist);
          innerShadow = innerShadow * innerShadow;
          vec2 dropShadowPos = correctedBubblePos + vec2(bubbleSize * 0.35, -bubbleSize * 0.4);
          float dropShadowDist = distance(correctedUV, dropShadowPos);
          float dropShadow = (1.0 - smoothstep(bubbleSize * 0.8, bubbleSize * 1.8, dropShadowDist)) * (1.0 - bubbleCore);
          vec3 bubbleColor = vec3(1.0);
          bubbleColor *= 0.85 + radialGradient * 0.15;
          bubbleColor += highlight * 0.6;
          bubbleColor -= innerShadow * 0.045;
          bubbleLayer += bubbleColor * bubbleCore * 0.7;
          bubbleLayer -= dropShadow * 0.06;
        }
        
        baseColor = baseColor * (1.0 - clamp(length(bubbleLayer) * 0.3, 0.0, 0.5)) + bubbleLayer;
        gl_FragColor = vec4(baseColor, 1.0);
      }
    `;

    const geometry = new THREE.PlaneGeometry(2, 2);
    config = getResponsiveConfig();
    const displayMaterial = new THREE.ShaderMaterial({
      uniforms: {
        uTime: { value: 0 },
        uResolution: { value: new THREE.Vector2(window.innerWidth, window.innerHeight) },
        uTexture: { value: textTexture },
        uBubbleCount: { value: config.bubbleCount },
        uMainFlowMultiplier: { value: currentDeform.mainFlowMultiplier },
        uRedFlowMultiplier: { value: currentDeform.redFlowMultiplier },
        uDeformStrength: { value: currentDeform.deformStrength },
        uVelocity: { value: null },
        uMouseTransparent: { value: mouseTransparent ? 1.0 : 0.0 }
      },
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
      transparent: true
    });

    const plane = new THREE.Mesh(geometry, displayMaterial);
    scene.add(plane);
    
    // 用于物理模拟的平面
    const simPlane = new THREE.Mesh(geometry, simulationMaterial);
    const simScene = new THREE.Scene();
    simScene.add(simPlane);
    
    // 鼠标交互
    let targetMouse = new THREE.Vector2(0.5, 0.5);
    let currentMouse = new THREE.Vector2(0.5, 0.5);
    let lastMouse = new THREE.Vector2(0.5, 0.5);
    
    window.addEventListener('mousemove', (e) => {
      targetMouse.x = e.clientX / window.innerWidth;
      targetMouse.y = 1.0 - e.clientY / window.innerHeight;
    });
    
    window.addEventListener('touchmove', (e) => {
      if (e.touches.length > 0) {
        const touch = e.touches[0];
        targetMouse.x = touch.clientX / window.innerWidth;
        targetMouse.y = 1.0 - touch.clientY / window.innerHeight;
      }
    }, { passive: true });
    
    window.addEventListener('touchstart', (e) => {
      if (e.touches.length > 0) {
        const touch = e.touches[0];
        targetMouse.x = touch.clientX / window.innerWidth;
        targetMouse.y = 1.0 - touch.clientY / window.innerHeight;
        currentMouse.copy(targetMouse);
        lastMouse.copy(targetMouse);
      }
    }, { passive: true });

    window.addEventListener('resize', () => {
      config = getResponsiveConfig();
      const maxPixelRatio = config.isMobile ? 2 : (config.isTablet ? 2 : 3);
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, maxPixelRatio));
      renderer.setSize(window.innerWidth, window.innerHeight);
      displayMaterial.uniforms.uResolution.value.x = window.innerWidth;
      displayMaterial.uniforms.uResolution.value.y = window.innerHeight;
      displayMaterial.uniforms.uBubbleCount.value = config.bubbleCount;
      simulationMaterial.uniforms.uAspect.value = window.innerWidth / window.innerHeight;
      const newTexture = createTextTexture();
      displayMaterial.uniforms.uTexture.value = newTexture;
    });

    const clock = new THREE.Clock();
    let animationId;
    
    function animate() {
      try {
        animationId = requestAnimationFrame(animate);
        const elapsedTime = clock.getElapsedTime();
        
        // 平滑鼠标移动
        currentMouse.x += (targetMouse.x - currentMouse.x) * 0.1;
        currentMouse.y += (targetMouse.y - currentMouse.y) * 0.1;
        
        // 计算速度向量
        let dir = new THREE.Vector2().subVectors(currentMouse, lastMouse);
        let speed = dir.length();
        
        // 更新物理模拟参数
        simulationMaterial.uniforms.uVelocity.value = velocityFBO_A.texture;
        simulationMaterial.uniforms.uMouse.value.copy(currentMouse);
        simulationMaterial.uniforms.uDir.value.copy(dir.length() > 0 ? dir.normalize() : new THREE.Vector2(0, 0));
        simulationMaterial.uniforms.uStrength.value = speed * 20.0;
        
        // 物理计算步骤（渲染到FBO）
        renderer.setRenderTarget(velocityFBO_B);
        renderer.render(simScene, camera);
        
        // 交换缓冲区
        [velocityFBO_A, velocityFBO_B] = [velocityFBO_B, velocityFBO_A];
        
        // 更新文字纹理
        const newTexture = createTextTexture(elapsedTime);
        displayMaterial.uniforms.uTexture.value = newTexture;
        displayMaterial.uniforms.uTexture.value.needsUpdate = true;
        displayMaterial.uniforms.uTime.value = elapsedTime;
        displayMaterial.uniforms.uVelocity.value = velocityFBO_A.texture;
        
        // 视觉输出步骤（渲染到屏幕）
        renderer.setRenderTarget(null);
        renderer.render(scene, camera);
        
        lastMouse.copy(currentMouse);
      } catch (error) {
        handleLoaderError(error, 'animate');
        cancelAnimationFrame(animationId);
        webGLFailed = true;
        enterHomePage();
      }
    }
    animate();
    
    // 暴露清理函数到全局，用于释放资源
    window.loaderCleanup = function() {
      if (animationId) {
        cancelAnimationFrame(animationId);
        animationId = null;
      }
      
      if (renderer) {
        renderer.dispose();
      }
      if (displayMaterial) {
        displayMaterial.dispose();
      }
      if (simulationMaterial) {
        simulationMaterial.dispose();
      }
      if (geometry) {
        geometry.dispose();
      }
      if (textTexture) {
        textTexture.dispose();
      }
      if (velocityFBO_A) {
        velocityFBO_A.dispose();
      }
      if (velocityFBO_B) {
        velocityFBO_B.dispose();
      }
      
      if (container && container.firstChild) {
        container.removeChild(container.firstChild);
      }
    };
  }
  }

  // 等待 DOM 加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoader);
  } else {
    // DOM 已经加载完成，直接初始化
    initLoader();
  }

})();
